import { render, staticRenderFns } from "./postBody.vue?vue&type=template&id=92b38b1e&"
import script from "./postBody.vue?vue&type=script&lang=js&"
export * from "./postBody.vue?vue&type=script&lang=js&"
import style0 from "./postBody.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports